type SheetIconProps = React.SVGProps<SVGSVGElement>;

export default function SheetIcon({ className, ...props }: SheetIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.875 10.125H12.375M7.875 7.875H12.375M5.625 2.8125V15.1875M3.375 2.8125H14.625C14.9357 2.8125 15.1875 3.06434 15.1875 3.375V14.625C15.1875 14.9357 14.9357 15.1875 14.625 15.1875H3.375C3.06434 15.1875 2.8125 14.9357 2.8125 14.625V3.375C2.8125 3.06434 3.06434 2.8125 3.375 2.8125Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
